import * as React from 'react';
import useAuth from '@/auth/use-auth';
import { getOtpTimeout } from '@/utils';
// import { useState, useEffect } from "react";

import './UiCode.scss';

type UiCodeProps = {
  phone: string;
};

const UiCode = ({ phone }: UiCodeProps) => {
  const { signIn, loginWithOtp } = useAuth();
  const [count, setCount] = React.useState<number>(() => getOtpTimeout());
  const [code, setCode] = React.useState<string>('');
  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
    const { value, maxLength } = event.target;
    setCode(() => value.replace(/[^0-9]/g, ''));
    if (inputRef.current && value.length >= maxLength) {
      inputRef.current.disabled = true;
      await loginWithOtp(inputRef.current?.value ?? '');
    }
  };

  const handleSignIn = async (): Promise<void> => {
    await signIn(phone);
  };

  React.useEffect(() => {
    let ac = new AbortController();
    setTimeout(() => {
      // abort after 10 minutes
      ac.abort();
    }, 10 * 60 * 1000);
    (navigator.credentials as any)
      .get({
        otp: { transport: ["sms"] },
        signal: ac.signal
      })
      .then((otp: any) => {
        if (otp != null) {
          setCode(otp.code);
          console.log("your otp code is", otp.code);
          setTimeout(() => loginWithOtp(otp.code), 1000);
        } else {
          console.log("otp is null")
        }
      })
      .catch((err: any) => {
        console.log(err);
      });

    const id = setInterval(() => {
      if (count > 0) {
        setCount(c => c - 1);
      }
    }, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="form-group">
      <div className="form-label" data-testid="title">
        Введите код из СМС
      </div>
      <div className="code">
        <div className="code-input">
          <span className="code-letter" />
          <span className="code-letter" />
          <span className="code-letter" />
          <span className="code-letter" />
          <span className="code-letter" />
          <span className="code-letter" />
          <input
            ref={inputRef}
            className="code-value index-element-1"
            type="text"
            maxLength={6}
            onChange={handleChange}
            name="one-time-code"
            value={code}
            data-testid="otp"
          />
        </div>
        <div className="code-timeout">
          {
            count > 0
              ? `запросить новый код можно через ${count} сек.`
              : (
                <button
                  className="code-resend"
                  type="button"
                  onClick={handleSignIn}
                >
                  запросить код
                </button>
              )
          }
        </div>
      </div>
    </div>
  );
};

export default UiCode;
